import React from 'react'
import styled from 'styled-components'
import { motion } from 'framer-motion'
import BondethImage from '../assets/Images/rithybondeth.jpg'
import { TabletSize } from '../responsive/TabletSize'
import { MobileSize } from '../responsive/MobileSize'

const Wrapper = styled(motion.div)`
    position: absolute;
    top: 25%;
    bottom: 25%;
    left: 20%;
    right: 20%;
    border-right: 5px solid transparent; 
    border-left: 5px solid transparent;
    border-top: 5px solid transparent;
    border-bottom: 5px solid transparent;
    display: flex;
    ${TabletSize({ 
      flexDirection: "column",
      top: "18%",
      bottom: "18%",
      left: "18%",
      right: "18%"
     })};
`;
const Conatiner = styled.div`
      width: 50%;
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
      align-items: start;
      border-left: 5px solid ${props => props.theme.body};
      border-top: 5px solid ${props => props.theme.body};
      border-bottom: 5px solid ${props => props.theme.body};
      ${TabletSize({ width: "100%", height: "50%" })};
      @media only screen and (max-width: 768px){
            border-right: 5px solid ${props => props.theme.body};
            border-bottom: 5px solid transparent;
      }
      
`;

const Text1 = styled.p`
      color: ${props => props.theme.body};
      font-size: 65px;
      padding: 0px 20px;
      ${TabletSize({ fontSize: "45px" })};
      ${MobileSize({ fontSize: "40px" })};
`;

const Text2 = styled(Text1)`
      font-size: 40px;
      ${TabletSize({ fontSize: "25px" })};
      ${MobileSize({ fontSize: "20px" })};
`;

const Text3 = styled(Text1)`
      font-size: 20px;
      ${TabletSize({ fontSize: "15px" })};
`;

const ProfileBox = styled.div`
      width: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      border-right: 5px solid ${props => props.theme.text};
      border-top: 5px solid ${props => props.theme.text};
      border-bottom: 5px solid ${props => props.theme.text};
      @media only screen and (max-width: 768px){
            border-left: 5px solid ${props => props.theme.text};
            border-top: 5px solid transparent;
      }
      ${TabletSize({ width: "100%", height: "50%" })};
`;

const ImageBox = styled.div`
      position: absolute;
      top: 10%;
      bottom: 10%;
      left: 15%;
      right: 15%;
      border: 5px solid ${props => props.theme.text};
      background-image: url(${BondethImage});
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
`;

const Popup = () => {
  return (
    <Wrapper
      animate={{ x: 0, scale: [1, 1.2, 1], rotate: 360 }}
      initial={{ x: -500 }}
      transition={{ duration: 1.5, type: "spring", dumping: 100 }}
    >
      <Conatiner>
        <Text1>Hi</Text1>
        <Text2>I'm Rithy Bondeth</Text2>
        <Text3>I'm a Web and Mobile App Developer</Text3>
      </Conatiner>
      <ProfileBox>
        <ImageBox>
        </ImageBox>
      </ProfileBox>
    </Wrapper>
  )
}

export default Popup